import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeGDSCommand extends BaseCommand {
  CommandName = "ChangeGDS";
  Command: {
    GDSId: number;
  };
  constructor(sessionId: string, operationId: string, value: number) {
    super(sessionId, operationId);
    this.Command = { GDSId: value };
  }
}
